import {combineReducers} from 'redux';

import {SelectionSliceFor} from '../../../../store/SelectionSliceFor';

const entityKey = 'pipelines';

const selectionSlice = SelectionSliceFor(entityKey);

export const {
    addToSelection,
    removeFromSelection,
    clearSelection,
} = selectionSlice.actions;

export const PipelinesReducer = combineReducers({
    selection: selectionSlice.reducer,
});
